<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <v-icon medium>
          mdi-account-multiple-outline
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">{{ type.toUpperCase() }} Roles</span>
      </v-col>
    </v-row>

    <v-row
      v-if="loading"
      no-gutters
    >
      <v-col>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </v-row>
    
    <div v-else>
      <v-row>
        <v-col
          v-if="noOfRoles > 0"
        >
          <v-chip        
            v-for="role in roles"                       
            :key="role.id"
            class="ma-1"
          >
            {{ role.name }}
          </v-chip>      
        </v-col>
        <v-col v-else>
          <span class="mx-2"> No data available </span>
        </v-col>
      </v-row>
    </div>

    <v-card-actions v-show="$hasPermissionTo(['update user roles']) && !isMyProfile">
      <v-spacer />
      <user-roles-dialog-edit        
        :type="type"
        :user-uid="userUid"
        @updated="loadUserRoles"
      />
    </v-card-actions>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      UserRolesDialogEdit: () => import('@/components/hris/user/roles/DialogEdit'),
    },
    props: {
      userUid: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        roles: [],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      noOfRoles () {
        return this.roles.length
      },
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserRoles()
          }
        },
      },
    },
    methods: {
      loadUserRoles () {
        this.loading = true

        this.$api.hrisUserRoles(this.type).list(this.userUid)
          .then((response) => {
            this.roles = response.data           
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
    },
  }
</script>
